import React from 'react';

import { defaultFormatters, defaultOperators } from 'components/Grid';
import { ColumnDefinition } from 'components/Grid/types';

import {
  DATETIME_COLUMN_MIN_WIDTH,
  DEFAULT_DATE_FORMAT_WITH_YEAR_AND_HOUR,
  EntityModules,
  ProtectorType,
} from 'core/constants';

import { formatMoment } from 'utils/formatters/timezone';

import { StyledCreated } from './styles';

export const entityCreatedColumn = (module: EntityModules): ColumnDefinition =>
  ({
    field: 'createdAt',
    headerName: 'Created',
    minWidth: DATETIME_COLUMN_MIN_WIDTH,
    renderCell: ({ value }: { value: { value: string } }) => (
      <StyledCreated data-testid={`${module}-created-at`}>
        {formatMoment(value.value, DEFAULT_DATE_FORMAT_WITH_YEAR_AND_HOUR)}
      </StyledCreated>
    ),
    filterOperators: defaultOperators.date_time(),
    valueFormatter: defaultFormatters.date_time,
    nativeFilter: 'createdAt',
    protectorType: ProtectorType.DateTime,
  }) as unknown as ColumnDefinition;
